import React from 'react';

import { orderBy } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Modal, T } from '@shared/components';

import { POStatusTypes } from '../../constants';
import { closedPOModalVisibleSel, hideClosedPOModal } from '../../duck';
import { useGetPurchaseOrders } from '../../hooks';
import { POCardPlaceholder } from '../POCardPlaceholder';
import { ClosedPOList } from './ClosedPOList';
import styles from './ClosedPOModal.less';

export const ClosedPOModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(closedPOModalVisibleSel);

  const {
    data: listPO,
    isLoading: isLoadingListPO,
    isFetching: isFetchingListPO,
  } = useGetPurchaseOrders();
  const closedOrders =
    listPO?.filter(po =>
      [POStatusTypes.CLOSED, POStatusTypes.EDITED].includes(po.status),
    ) || [];
  const sortedClosedOrders = orderBy(
    closedOrders,
    [po => new Date(po.dateCreated), 'poid'],
    ['desc', 'desc'],
  );

  const handleCancel = () => dispatch(hideClosedPOModal());

  return (
    <Modal
      visible={isOpen}
      onCancel={handleCancel}
      size="large"
      centered
      showMobileHeader
      backTitle={<FormattedMessage id="purchaseOrder.ClosedPOModal.backTitle" />}
    >
      <T size="4" className={styles.modalTitle}>
        <FormattedMessage id="purchaseOrder.ClosedPOModal.title" />
      </T>
      {!isLoadingListPO && !isFetchingListPO && sortedClosedOrders.length ? (
        <ClosedPOList orders={sortedClosedOrders} />
      ) : (
        <POCardPlaceholder
          isLoading={isLoadingListPO || isFetchingListPO}
          status={POStatusTypes.CLOSED}
        />
      )}
    </Modal>
  );
};
